import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'react-mdl/extra/material.css';
import 'react-mdl/extra/material.js';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import './App.css';
import * as serviceWorker from './serviceWorker';
import history from './utils/History';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { QueryClient, QueryClientProvider } from 'react-query';

//BrowserRouter: This is a router implementation from react-router-dom that uses the HTML5 history API. It's given a custom history object and a base URL.

//Provider: This is a Redux provider that makes the Redux store available to all components within the app.

// Create a client
export const queryClient = new QueryClient();
ReactDOM.render(
  <Router history={history} basename={'/'}>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <App />
      </Provider>
    </QueryClientProvider>
  </Router>,
  document.getElementById('root')
);

serviceWorker.unregister();
